import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';

import { company } from '~/company/Company';
import { useStatusBarControl } from '~/hooks/useStatusBarControl';
import { AnalyticsEvent, analyticsService } from '~/services/analytics';
import { userStore } from '~/stores';

import ContentBottomSheet from '../../components/ContentBottomSheet/ContentBottomSheet';
import { Form } from '../../components/Form/Form';
import ProgressIndicator from '../../components/ProgressIndicator/ProgressIndicator';
import { useOnboardingHandlers } from '../../hooks/useOnboardingHandlers';
import { useStepData } from '../../hooks/useStepData';
import styles from './CityDrinksOnboarding.module.scss';

const CityDrinksOnboardingComponent = () => {
  const {
    handleChangeScreenIndex,
    handleTimerAlive,
    currentStepData,
    currentStep,
    additionalData,
    stepsNumber,
  } = useStepData();

  const {
    isLatestStep,
    handleLaterPress,
    handleNextPress,
    handlePrevPress,
    handleSubmitForm,
  } = useOnboardingHandlers({
    currentStep,
    stepsNumber,
    handleChangeScreenIndex,
    handleTimerAlive,
  });

  useStatusBarControl({
    initialColor: 'dark-content',
  });

  useEffect(() => {
    const dialogPayload = {
      type: 'no_store',
      postcode: userStore.deliveryAddress?.zip || '',
      lat: userStore.deliveryAddress?.coordinates.lat || '',
      lon: userStore.deliveryAddress?.coordinates.lng || '',
    };
    analyticsService.track(
      AnalyticsEvent.ONBOARDING_SUBSCRIBE_DIALOG_SHOWN,
      dialogPayload,
    );
    analyticsService.track(
      AnalyticsEvent.ONBOARDING_SUBSCRIBE_DIALOG_SHOWN_BI,
      dialogPayload,
    );
  }, []);

  return (
    <div
      className={classes([styles.onboarding, styles.new])}
      style={{
        background: additionalData?.backgroundColor,
      }}
      data-company={company.name}
    >
      {isLatestStep && (
        <Form
          isVisibleInputs={false}
          isVisibleInputLabels={additionalData?.isVisibleInputLabels}
          emailPlaceholder={additionalData?.inputEmailPlaceholder}
          firstNamePlaceholder={additionalData?.inputFirstNamePlaceholder}
          onSubmitForm={handleSubmitForm}
          onLaterPress={handleLaterPress}
          onPrevPress={handlePrevPress}
        />
      )}

      <div className={styles.imageContainer}>
        <div
          className={classes([
            styles.image,
            styles.new,
            isLatestStep && styles.isLarge,
          ])}
          style={{
            backgroundImage: `url('${currentStepData?.img}')`,
            backgroundPosition: currentStepData?.position || 'bottom',
          }}
        />
      </div>

      {!isLatestStep && (
        <ContentBottomSheet
          isVisibleInputs={false}
          isLatestStep={isLatestStep}
          isVisibleInputLabels={additionalData?.isVisibleInputLabels}
          skipButtonText={additionalData?.skipButtonText}
          emailPlaceholder={additionalData?.inputEmailPlaceholder}
          firstNamePlaceholder={additionalData?.inputFirstNamePlaceholder}
          currentPage={currentStep}
          showBackButton={false}
          onNextPress={handleNextPress}
          onSubmitForm={handleSubmitForm}
          onLaterPress={handleLaterPress}
          onPrevPress={handlePrevPress}
          buttonsHeader={
            <ProgressIndicator
              stepsNumber={stepsNumber}
              activeStep={currentStep}
              noPadding={true}
            />
          }
          title={currentStepData?.textTitle || ''}
          description={currentStepData?.textDescription || ''}
        />
      )}

      {isLatestStep && (
        <div className={styles.progressIndicator}>
          <ProgressIndicator
            stepsNumber={stepsNumber}
            activeStep={currentStep}
            noPadding={false}
          />
        </div>
      )}
    </div>
  );
};

export const CityDrinksOnboarding = observer(CityDrinksOnboardingComponent);
